import type { CaseStudyContent } from './caseStudies/types'
import {
  absoluteUrl,
  canonicalLink,
  DEFAULT_OG_IMAGE,
  jsonLd,
  seoMeta,
  SITE_URL,
} from './seo'

export function caseStudyHead(content: CaseStudyContent) {
  const image = content.ogImage ?? DEFAULT_OG_IMAGE

  return {
    meta: seoMeta({
      title: content.metaTitle,
      description: content.metaDescription,
      path: content.path,
      image,
      type: 'article',
    }),
    links: [canonicalLink(content.path)],
    scripts: [
      jsonLd({
        '@context': 'https://schema.org',
        '@type': 'CreativeWork',
        '@id': `${absoluteUrl(content.path)}#case-study`,
        url: absoluteUrl(content.path),
        name: content.metaTitle,
        description: content.metaDescription,
        image: absoluteUrl(image),
        publisher: { '@id': `${SITE_URL}/#organization` },
        author: { '@id': `${SITE_URL}/#organization` },
        mainEntityOfPage: absoluteUrl(content.path),
      }),
    ],
  }
}
